/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_HeadInputs */

const en_wb_operations_head = /** @type {(inputs: Wb_Operations_HeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order #1048`)
};

const lv_wb_operations_head = /** @type {(inputs: Wb_Operations_HeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasūtījums #1048`)
};

/**
* | output |
* | --- |
* | "Order #1048" |
*
* @param {Wb_Operations_HeadInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_head = /** @type {((inputs?: Wb_Operations_HeadInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_HeadInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_head(inputs)
	return en_wb_operations_head(inputs)
});